import Fallback from './Fallback';

export default Fallback;
